import { render, staticRenderFns } from "./ConfigureUser.vue?vue&type=template&id=1b9d6ad5&scoped=true&"
import script from "./ConfigureUser.vue?vue&type=script&lang=js&"
export * from "./ConfigureUser.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureUser.vue?vue&type=style&index=0&id=1b9d6ad5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9d6ad5",
  null
  
)

export default component.exports